/* ============
 * ShippingConfirm Transformer
 * ============
 */

import Transformer from './transformer';
import moment from 'moment';

export default class ShippingConfirmTransformer extends Transformer {

  static fetch(shipping) {
    return {
      shippingProviderId: shipping.shipping_provider_id,
      shippingDate: shipping.delivery_date,
      confirmDate: shipping.confirm_date,
    };
  }

  static send(shipping) {
    return {
      shipping_provider_id: shipping.shippingProviderId,
      warehouse_id: shipping.warehouseId,
      delivery_date: shipping.deliveryDate ? moment(shipping.deliveryDate).format('Y-MM-DD HH:mm:ss') : '',
      shipping_date: shipping.shippingDate ? moment(shipping.shippingDate).format('Y-MM-DD HH:mm:ss') : '',
      confirm_date: shipping.confirmDate ? moment(shipping.confirmDate).format('Y-MM-DD HH:mm:ss') : '',
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/shippingConfirm.js